import { CarrierDto, CarrierHierarchyDto, GroupDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { convertHyphenated } from '../../../../core/util/string-conversion';
import { carrierReview } from '../../../carriers/logic/carrier-review';

/** The container. Anything else under an organisation is an operating unit. */
export const CARRIER_ORGANISATION_SUBTYPE = 'carrier-organisation';

export type CarrierGroupVariant = 'organisation' | 'unit';

export function carrierGroupVariant(subType?: string): CarrierGroupVariant {
  return subType === CARRIER_ORGANISATION_SUBTYPE ? 'organisation' : 'unit';
}

/** The flat shape both variants edit. Display-only fields are never sent. */
export interface CarrierGroupForm {
  name?: string;
  /** Display only: the managing project's name. Moving a group is its own operation. */
  parent?: string;
  /** Display only, title-cased. */
  status?: string;
  /** Unit only. */
  image?: string;
  /** Unit only. */
  review?: string;
  kioskRegistrationPolicy?: string;
  qrRegistrationPolicy?: string;
  /** Organisation only: the operating unit its self-registrations land in. */
  registrationTarget?: string;
  /** The organisation's own, inherited by its units. A unit reads back the effective one, so only a change is sent. */
  loginMethod?: string;
}

function display(value?: string): string | undefined {
  return value ? convertHyphenated(value, { capitalizeEachWord: true }) : undefined;
}

export class CarrierGroupFormData {
  /**
   * Policies come from the registration target: a container never appears on a kiosk, the target
   * unit does, under the organisation's name.
   */
  static FromOrganisation(group?: GroupDto, hierarchy?: CarrierHierarchyDto, target?: CarrierDto): CarrierGroupForm {
    return {
      name: group?.name,
      parent: group?.managedBy?.name,
      status: display(group?.status),
      registrationTarget: hierarchy?.organisation?.registrationTargetGroupID,
      loginMethod: hierarchy?.organisation?.loginMethod,
      kioskRegistrationPolicy: target?.kioskRegistrationPolicy,
      qrRegistrationPolicy: target?.qrRegistrationPolicy
    };
  }

  static FromUnit(carrier?: CarrierDto): CarrierGroupForm {
    return {
      name: carrier?.name,
      parent: carrier?.managedBy?.name,
      status: display(carrier?.status),
      image: carrier?.image,
      // Unset until loaded, so it never reads as approved early.
      review: carrier ? carrierReview(carrier) : undefined,
      kioskRegistrationPolicy: carrier?.kioskRegistrationPolicy,
      qrRegistrationPolicy: carrier?.qrRegistrationPolicy,
      loginMethod: carrier?.loginMethod
    };
  }
}
